import { Form, Input, Row, Col, Switch, InputNumber, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebProductCategoryEdit = (props: any) => {

    const apiId = 'webProductCategory';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [productNatureData, setProductNatureData] = useState<any>();

    useEffect(() => {
        //获取通用数据-产品退货规则
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'productNature',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setProductNatureData(res.data)
                }
            });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'webProductCategory',
        displayOptions: {
            width: 700
        },
        formOptions: {
            instance: form,
            children: (
                <Row >
                    <Col span={10}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="大类"
                            name="categoryName"
                            rules={[{ required: true, message: '产品大类!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="​性质"
                            name="productNatureId"
                            rules={[{ required: true, message: '​产品性质!' }]}>
                            <Select
                                placeholder="​产品性质"
                                showSearch={{ optionFilterProp: 'label' }}
                                options={getList.general2(productNatureData)}>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="排序"
                            name="sortBy">
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebProductCategoryEdit;